module.exports = __webpack_public_path__ + "img/default-sp.a95cd65f.png";